var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBathroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20837 11.2734V13.7484C3.20837 15.9484 5.04171 17.7818 7.33337 17.7818H14.6667C16.9584 17.7818 18.7917 15.9484 18.7917 13.7484V11.2734",
    stroke: "#8B8C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57494 8.70703H18.2416C19.0666 8.70703 19.7083 9.3487 19.7083 10.082C19.7083 10.8154 19.0666 11.457 18.2416 11.457H3.57494C2.74994 11.457 2.10828 10.8154 2.10828 10.082C2.19994 9.3487 2.84161 8.70703 3.57494 8.70703Z",
    stroke: "#8B8C9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 8.70755V3.84922C4.125 2.93255 4.85833 2.19922 5.775 2.19922C6.69167 2.19922 7.425 2.93255 7.425 3.84922V5.13255",
    stroke: "#8B8C9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41663 5.5H8.43329",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 17.7852V19.7102",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 17.7852V19.7102",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.39626b49.svg";
export { ForwardRef as ReactComponent };